import common from './common';
import page from './page';

export default {
  ...common,
  ...page,
};
